export const TYPING_DEBOUNCE_TIME = 300; // ms
export const QUERY_SUBSCRIBE_DEBOUNCE = 100; // ms
export const VALUE_CHANGES_DEBOUNCE = 100; // ms

export const REFRESH_DATA_INTERVAL = 10 * 60 * 1000; // 10 minutes

export const IMAGE_PLACEHOLDER = '/assets/images/image-placeholder.png';

export const APP_HEADER_HEIGHT_PX = 70; // same to $app-header-height in variables.scss

export const GOOGLE_FIND_PLACE_MAX_RADIUS = 50; // km

export const IFRAME_EVENT_NAME = {
  REMOVE_TOKEN: 'removeToken',
  SAVE_TOKEN: 'saveToken',
  ENABLE_IFRAME_MODE_REQUIRED: 'enableIframeModeRequired',
  ENABLE_IFRAME_MODE: 'enableIframeMode',
};
